/** Values are the strings the feedback API expects. */
export enum FeedbackCategory {
  Application = 'Application',
  ProcessTaskChecklist = 'ProcessTaskChecklist',
  Other = 'Other'
}

export const feedbackCategoryLabels: Readonly<
  Record<FeedbackCategory, string>
> = {
  [FeedbackCategory.Application]: 'Application',
  [FeedbackCategory.ProcessTaskChecklist]: 'Process, task or checklist',
  [FeedbackCategory.Other]: 'Other'
};
